export default __webpack_public_path__ + "static/media/Aura-Egg__65.084c7312.png";